import { AlertCircle } from "lucide-react";
import { FadeUp } from "./Reveal";

const IMG_1 =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_family-church-fund/artifacts/tjeiuhr4_WhatsApp%20Image%202026-07-20%20at%2015.52.25.jpeg";
const IMG_2 =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_family-church-fund/artifacts/ojt501rn_WhatsApp%20Image%202026-07-20%20at%2015.52.25%20%281%29.jpeg";

export const MentalHealthUpdate = () => {
  return (
    <section className="relative py-20 sm:py-28 bg-ink text-sand" data-testid="mental-health-section">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <FadeUp className="lg:col-span-5">
          <div className="inline-flex items-center gap-2 text-terracotta">
            <AlertCircle className="h-4 w-4" />
            <span className="text-xs font-semibold uppercase tracking-[0.24em]">
              Urgent update &middot; 20 July 2026
            </span>
          </div>
          <h2 className="mt-5 font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight text-sand">
            The invisible crisis: emotional recovery.
          </h2>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-sand/75">
            Alongside the physical rebuilding, an urgent mental-health crisis is
            unfolding. The level of desperation is severe, people are taking
            their own lives. In response, the pastors in La Guaira are organising
            emergency training in psychological recovery so they can support their
            communities in the days and weeks ahead.
          </p>

          <ul className="mt-7 space-y-3 text-sm text-sand/80">
            <li className="flex gap-3">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
              <span>
                On Saturday, a training was held for pastors and leaders in
                psychological recovery for survivors.
              </span>
            </li>
            <li className="flex gap-3">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
              <span>
                Today, 80 pastors are registered for a follow-up training in
                Caracas, and are actively coordinating relief on the ground.
              </span>
            </li>
            <li className="flex gap-3">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
              <span>
                In parallel, clothing, food and medicine were delivered today to a
                community called Osma.
              </span>
            </li>
          </ul>

          <blockquote className="mt-8 border-l-2 border-terracotta pl-5 text-sand/70">
            <p className="font-serif text-lg italic leading-snug">
              &ldquo;It is very sad to see the level of desperation of the people.&rdquo;
            </p>
            <footer className="mt-2 text-xs uppercase tracking-[0.18em] text-sand/50">
              Dra. Milagros Lezama
            </footer>
          </blockquote>

          <p className="mt-6 text-xs leading-relaxed text-sand/45" data-testid="mental-health-attribution">
            This update, the quote and the photos were shared personally by Dra. Milagros Lezama,
            mother of David Parra Lezama, who is in close contact with Pastor Ángel Aner González.
          </p>
        </FadeUp>

        <FadeUp delay={0.15} className="lg:col-span-7">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
            <div className="relative aspect-[4/5] overflow-hidden border border-sand/10">
              <img
                src={IMG_1}
                alt="Pastors gathered for psychological recovery training in La Guaira"
                className="absolute inset-0 h-full w-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="relative aspect-[4/5] overflow-hidden border border-sand/10 sm:mt-10">
              <img
                src={IMG_2}
                alt="Pastor addressing a fellow pastor during the training session"
                className="absolute inset-0 h-full w-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.16em] text-sand/40">
            Training with local pastors &middot; La Guaira, July 2026
          </p>
        </FadeUp>
      </div>
    </section>
  );
};

export default MentalHealthUpdate;
